/* global courses, schools */

import { Component } from 'react';
import { NavLink } from 'react-router-dom';

export default class Navigation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            courses: courses,
            schools: schools,
            restplassCount: window.restplassActive ? 1 : 0,
        };
    }

    render() {
        let path = window.location.pathname;
        return (
            <div>
                {this.state.restplassCount ? (
                    <div className="hero__nav hero__nav--restplass">
                        <a
                            href="/"
                            className={"hero__item hero__item--restplass" + (path === '/' ? ' hero__item--active' : '')}
                        > Restplasser
                        </a>
                        <a
                            href="/linjer"
                            className={"hero__item hero__item--courses" + (path === '/linjer' ? ' hero__item--active' : '')}
                        > Alle linjer
                        </a>
                        <NavLink
                            to="/skoler"
                            className={({ isActive, isPending }) =>
                                !isActive ? "hero__item hero__item--schools" : "hero__item hero__item--schools hero__item--active"
                            }
                        > Alle skoler
                        </NavLink>
                    </div>
                ) : (
                    <div className="hero__nav">
                        <NavLink
                            to="/"
                            className={({ isActive, isPending }) =>
                                !isActive ? "hero__item hero__item--courses" : "hero__item hero__item--courses hero__item--active"
                            }
                        > Finn din linje
                        </NavLink>
                        <NavLink
                            to="/skoler"
                            className={({ isActive, isPending }) =>
                                !isActive ? "hero__item hero__item--schools" : "hero__item hero__item--schools hero__item--active"
                            }
                        > Finn din skole
                        </NavLink>
                    </div>
                )}
            </div>
        );
    }
}
